import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import moment from 'moment'
import Icon from 'meinian-package/src/component/icon'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import request from 'meinian-package/src/utils/request'
import Button from 'meinian-package/src/baseComponent/button'
import { message } from 'antd'
import { CONFIG_KEY, OPTION_ITEM_TYPE, SOURCE_TYPE, DY_CONFIG, getViewConfig } from './config'
import ModuleItem from '../detail/moduleItem'
import styles from './index.module.less'

const qs = (obj) => {
  const search = []
  for (const key in obj) {
    if (obj[key] !== undefined) { search.push(`${key}=${encodeURIComponent(obj[key])}`) }
  }
  return search.join('&')
}

export const hasFromData = (cur:any, val, dto) => {
  if (typeof cur === 'object' && Object.prototype.hasOwnProperty.call(cur, 'fromData')) {
    return cur.fromData(val, dto)
  }
  return val
}

const hasCustomizeFromData = (cur:any, cusVal, val) => {
  if (typeof cur === 'object' && Object.prototype.hasOwnProperty.call(cur, 'customizeFromData')) {
    return cur.customizeFromData(cusVal)
  }
  return val
}

const hasSourceType = (cur, dto, curItem) => {
  if (cur.type === SOURCE_TYPE.DTO) {
    return dto
  }
  return curItem
}

export default ({ currentImage }) => {
  const platformId = Number(currentImage?.platformId)
  const { config, dtoConfig } = getViewConfig(platformId, currentImage?.isFromZkPlatform)
  const dto = currentImage?.[dtoConfig?.dto]
  const keys = config ? Object.keys(config) : []
  const onOriginLink = (dataSource:any) => {
    if (!dataSource.linkUrl) { return }
    const _query = {}
    if (dataSource?.query) {
      Object.keys(dataSource?.query).forEach((queryKey) => {
        _query[queryKey] = dto[dataSource.query[queryKey]]
      })
    }
    if (typeof dataSource.linkUrl === 'function') {
      dataSource.linkUrl(dto, currentImage)
    } else {
      const link = dataSource.defaultQuery ? `${dataSource.linkUrl}?${qs(_query)}${dataSource.defaultQuery}` : `${dataSource.linkUrl}?${qs(_query)}`
      window.open(link)
    }
  }

  const onOriginTextLink = (dataSource:any) => {
    const _query = {}
    if (dataSource?.query) {
      Object.keys(dataSource.query).forEach((queryKey) => {
        _query[queryKey] = dataSource.type === SOURCE_TYPE.DTO ? dto[dataSource.query[queryKey]] : currentImage[dataSource.query[queryKey]]
      })
    }
    if (typeof dataSource.linkUrl === 'function') {
      dataSource.linkUrl(dto, currentImage)
    } else {
      const link = `${dataSource.linkUrl}?${qs(_query)}`
      window.open(link)
    }
  }
  return <div className={styles.infoBlock}>
    <div className={styles.titleLine}>
      <div className={styles.point} /><div className={styles.mainTitle}>原文信息</div>
    </div>
    {
      platformId === PLATFORM_VALUE.DY && <DY
        dto={dto}
        dtoConfig={dtoConfig}
        currentImage={currentImage}
        onOriginTextLink={onOriginTextLink}
      />
    }
    {
      platformId !== PLATFORM_VALUE.DY && <div className={styles.infoBlockContext}>
        {
        keys.map(key => <Template
          tKey={key}
          keys={keys}
          key={key}
          dto={dto}
          dtoConfig={dtoConfig}
          tConfig={config}
          currentImage={currentImage}
          onOriginLink={onOriginLink}
          onOriginTextLink={onOriginTextLink}
        />)
      }
      </div>
    }
  </div>
}

const DY = ({ dto, dtoConfig, currentImage, onOriginTextLink }) => {
  const [hostId, setHostId] = useState()
  const [relateStreamerName, setRelateStreamerName] = useState('')
  useEffect(() => {
    fetchHostInfo()
  }, [dto.shopId])

  const fetchHostInfo = async () => {
    const res:any = await request.get('/v1-0-7/douyin/shop/info', { params: { shopId: dto.shopId } })
    setHostId(res.relateStreamerId)
    setRelateStreamerName(res.relateStreamerName)
  }

  const _config = hostId ? DY_CONFIG[0] : DY_CONFIG[1]
  const keys = _config ? Object.keys(_config) : []
  const _dto = { ...dto, relateStreamerName, hostId }

  const onOriginLink = (dataSource:any) => {
    if (!dataSource.linkUrl) { return }
    const _query = {}

    if (dataSource?.query) {
      Object.keys(dataSource?.query).forEach((queryKey) => {
        _query[queryKey] = _dto[dataSource.query[queryKey]]
      })
    }

    if (typeof dataSource.linkUrl === 'function') {
      dataSource.linkUrl(_dto, currentImage)
    } else {
      const link = dataSource.defaultQuery ? `${dataSource.linkUrl}?${qs(_query)}${dataSource.defaultQuery}` : `${dataSource.linkUrl}?${qs(_query)}`
      window.open(link)
    }
  }

  return <div className={styles.infoBlockContext}>
    {
        keys.map(key => <Template
          tKey={key} // tempKey
          key={key}
          keys={keys}
          dto={_dto}
          dtoConfig={dtoConfig}
          tConfig={_config}
          currentImage={currentImage}
          onOriginLink={onOriginLink}
          onOriginTextLink={onOriginTextLink}
        />)
      }
  </div>
}

const Template = ({ keys, tKey, dto, dtoConfig, tConfig, currentImage, onOriginLink, onOriginTextLink }) => {
  const getOptionItemValue = (item) => {
    if (item.type === OPTION_ITEM_TYPE.DTO) {
      return hasSourceType(item.type, dto, currentImage)[item.valueKey]
    }
    if (item.type === OPTION_ITEM_TYPE.TIME) {
      return moment(dto[item.valueKey]).format('YYYY/MM/DD HH:mm:ss')
    }
    if (item.type === OPTION_ITEM_TYPE.DATA) {
      return moment(hasSourceType(item.type, dto, currentImage)[item.valueKey]).format('YYYY/MM/DD')
    }
  }
  return <>
    {tKey === CONFIG_KEY.TITLE && <div
      className={classNames(
        styles.originalTextInfoTitle,
        'text-overflow',
        { 'cursor-pointer': tConfig[tKey].linkUrl, [styles['link-btn']]: tConfig[tKey].linkUrl }
      )}
      style={{ marginBottom: keys.some(item => item === CONFIG_KEY.PRICE) ? '4px' : '12px' }}
      onClick={() => onOriginLink(tConfig[tKey])}
    >
        {hasCustomizeFromData(tConfig[tKey], dto, dto[tConfig[tKey].labelKey])}
    </div>}
    {tKey === CONFIG_KEY.PRICE && <div className={styles.originalTextInfoPrice}>
        {
          tConfig[tKey][0] && <div className={styles.currentPrice}>{hasFromData(tConfig[tKey][0], dto[tConfig[tKey][0].valueKey], dto)}</div>
        }
        {
          tConfig[tKey][1] && <div className={styles.historyPrice}>
            {tConfig[tKey][1].label || '历史最低价：'}
            {hasFromData(tConfig[tKey][1], dto[tConfig[tKey][1].valueKey], dto)}</div>
        }
      </div>}
    {tKey === CONFIG_KEY.INFO_BLOCK && <div className={styles.originalTextInfoDetail}>
      <div className={styles.originalTextInfoDetailCardWrap}>
        {
          tConfig[tKey].map(item => <div className={classNames(styles.originalTextInfoDetailCard)}>
            {
              Array.isArray(item.valueKey) ? <>
                <div className={styles.originalTextInfoDetailCardTitle}>{item.label}</div>
                <div className={styles.originalTextInfoDetailCardData}>{hasFromData(item, dto[item.valueKey[0]], dto)}<span style={{ color: 'var(--m-text-2)', fontWeight: 400, }}>/{hasFromData(item, dto[item.valueKey[1]], dto)}</span></div>
              </> : <>
                <div className={styles.originalTextInfoDetailCardTitle}>{item.label}</div>
                <div className={styles.originalTextInfoDetailCardData}>{hasFromData(item, dto[item.valueKey], dto)}</div>
              </>
            }
          </div>)
        }
      </div>
    </div>}
    {
        tKey === CONFIG_KEY.EXTERNAL_LINK && <div
          className={classNames(styles.originalTextInfoExternalLink)}
        >
          站外
          <div>
            {
              tConfig[tKey].map(item => <Button onClick={() => onOriginLink(item)} type="link" className={classNames(styles.originalTextInfoExternalLinkBtn)}>
                <div className={classNames('text-overflow')} style={{ maxWidth: '120px' }}>{item.label || hasCustomizeFromData(item, dto, dto[item.labelKey])}</div>
                <div className={styles.rightIcon}><Icon type="m-Vxing_you" /></div>
              </Button>)
            }
          </div>
        </div>
      }
    {tKey === CONFIG_KEY.ORIGIN_LINK && <div className={styles.originalTextInfoInspiration}>
      站内
      <span className={styles.originalTextInfoInspirationWrap}>
        {
          tConfig[tKey][0] && <span onClick={() => {
            if (tConfig[tKey][0].message) {
              message.info(tConfig[tKey][0].message)
            } else {
              onOriginLink(tConfig[tKey][0])
            }
          }}
          >
            <Button
              type="link"
              disabled={tConfig[tKey][0].message}
              className={classNames(styles.originalTextInfoInspirationLeft)}
            >
              <div className={styles.label}>
                {tConfig[tKey][0]?.customizeTypeKey ? dto[tConfig[tKey][0].customizeTypeKey] : tConfig[tKey][0].type}：</div>
              <div className={classNames(styles.value, 'text-overflow')}>{hasCustomizeFromData(tConfig[tKey][0], dto, dto[tConfig[tKey][0].labelKey])}</div>
              <div className={styles.rightIcon}><Icon type="m-Vxing_you" /></div>
            </Button>
          </span>
        }
        <span
          onClick={() => {
            if (tConfig[tKey][1].message) {
              message.info(tConfig[tKey][1].message)
            } else {
              onOriginTextLink(tConfig[tKey][1])
            }
          }}
        >
          <Button
            type="link"
            disabled={tConfig[tKey][1].message}
            className={classNames(styles.originalTextInfoInspirationRight)}
          >
            {tConfig[tKey][1]?.label}原文
            <div className={styles.rightIcon}><Icon type="m-Vxing_you" /></div>
          </Button>
        </span>
      </span>
    </div>}
    {tKey === CONFIG_KEY.OPTION_ITEM && <>
      <ModuleItem
        label="款式来源"
        mb12={false}
        style={{ marginBottom: '8px' }}
        value={dtoConfig?.label || currentImage[dtoConfig?.labelKey]}
      />
      {tConfig[tKey].map(item => <ModuleItem
        label={item.label}
        mb12={false}
        style={{ marginBottom: '8px' }}
        value={getOptionItemValue(item)}
      />)}
    </>}
  </>
}
